import * as constants from '../constants'
import { PositionsInputs } from '../types'
import { TradingAction } from '../actions'
import { SetTakeProfit, SetStopLoss, SetPrice } from '../actions/TradeActions'

export function positionsInputs(
  inputsState: PositionsInputs = {},
  action: TradingAction | SetTakeProfit | SetStopLoss | SetPrice
): PositionsInputs {
  switch (action.type) {
    case constants.INPUT_POSITION_STOPLOSS:
      return {
        ...inputsState,
        [action.order]: { ...(inputsState[action.order] || {}), slInput: action.stopLoss },
      }
    case constants.INPUT_POSITION_TAKEPROFIT:
      return {
        ...inputsState,
        [action.order]: { ...(inputsState[action.order] || {}), tpInput: action.takeProfit },
      }
    case constants.INPUT_POSITION_PRICE:
      return {
        ...inputsState,
        [action.order]: { ...(inputsState[action.order] || {}), priceInput: action.price },
      }
    case constants.SET_STOPLOSS:
      return { ...inputsState, [-1]: { ...(inputsState[-1] || {}), slInput: action.stopLoss } }
    case constants.SET_TAKEPROFIT:
      return { ...inputsState, [-1]: { ...(inputsState[-1] || {}), tpInput: action.takeProfit } }
    case constants.SET_PRICE:
      return { ...inputsState, [-1]: { ...(inputsState[-1] || {}), priceInput: action.price } }
    default:
      return inputsState
  }
}
